import { GET } from '../../Commons/Utils/fetch';

export const getInstructors = async ({ page = 1, limit = 28, sort = 'latest' } = {}) => {
  const res = await GET({ url: '/auth/instructors', params: { page, limit, sort } });
  return res.data;
};

export const getInstructorDetail = async (id) => {
  const res = await GET({ url: `/auth/instructors/${id}` });
  return res.data.instructor;
};
